import React, { useEffect, useState } from 'react'
import { getBadgeCategory } from 'services/badge.routes';
import Loading from 'components/Loading';
import { toast } from 'react-toastify';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import BadgeCategoryTable from './BadgeCategoryTable';

export default function BadgeCategory() {
    const [loading, setLoading] = useState(false);
    const [badgeCategory, setBadgeCategory] = useState([]);

    useEffect(() => {
        setLoading(true);

        getBadgeCategory((isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message)
            } else {
                setBadgeCategory(data);
            }
        })
    }, []);
    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <BadgeCategoryTable data={badgeCategory} />
        </DashboardLayout>
    )
}
